<template>
	<form class="signUpForm" @submit.prevent="doValidation()">
		<div class="login-center-wrap">
			<div style="width: 25%; margin-right: 2vw; display: flex; flex-direction: column; align-items: center;" class="media">
				<div style="letter-spacing: -0.04em; font-size: 40px; font-family: Pretendard; font-weight: 600 !important; margin-bottom: 30px;">개인정보 처리방침</div>
				<span style="overflow: auto; height: 53vh;">
					'스마트안심산모24'은 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다. 스마트안심산모24은 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
					<br><br>※ 개인정보의 처리목적
					<br>스마트안심산모24은 수집한 개인정보를 다음의 목적을 위해 활용합니다.
					<br>	
					<br>※ 홈페이지 회원관리에 관한 사항
					<br>수집데이터에 대한 응급조치 등 알람서비스에 관한 사항
					<br>각종 상담신청에 관한 사항
					<br>고객의 민원처리에 관한 사항
					<br>처리하는 개인정보의 수집방법
					<br>스마트안심산모24은 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
					<br>
					<br>※ 수집항목
					<br>필수 : 아이디, 비밀번호, 이름, 전화번호, 이메일
					<br>선택 : 생년월일, 헬스 데이터(Health Data)
					<br>수집방법 : 홈페이지 회원가입
					<br>개인정보의 처리 및 보유기간
					<br>스마트안심산모24은 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다. 회원정보는 회원탈퇴 또는 휴면 전환 후 2년 미이용 시 파기합니다. 단, 진료서비스 제공을 위하여 수집된 경우 의료법에 명시된 진료기록 보관 기준에 준합니다.
					<br>
					<br>※ 개인정보의 제3자 제공
					<br>스마트안심산모24은 귀하의 동의가 있거나 관련법령의 규정에 의한 경우를 제외하고는 어떠한 경우에도 ‘개인정보 처리방침’에서 고지한 범위를 넘어 귀하의 개인정보를 이용하거나 타인 또는 타기관에 제공하지 않습니다.
					<br>
					<br>※ 다만, 아래의 경우에는 예외로 합니다.
					<br>1. 정보주체의 동의를 받은 경우
					<br>2. 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우
					<br>3. 정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우
					<br>4. 통계작성. 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
					<br>5. 개인정보를 목적 외의 용도로 이용하거나 이를 제3자에게 제공하지 아니하면 다른 법률에서 정하는 소관 업무를 수행할 수 없는 경우로서 보호위원회의 심의·의결을 거친 경우
					<br>6. 조약, 그 밖의 국제협정의 이행을 위하여 외국정부 또는 국제기구에 제공하기 위하여 필요한 경우
					<br>7. 범죄의 수사와 공소의 제기 및 유지를 위하여 필요한 경우
					<br>8. 법원의 재판업무 수행을 위하여 필요한 경우
					<br>9. 형 및 감호, 보호처분의 집행을 위하여 필요한 경우
					<br>상기 개인정보 수집항목은 홈페이지 서비스를 제공하는데 필요한 최소한의 정보에 해당하므로 상기내용에 대하여 본인이 동의하지 않을 수 있으며, 미 동의로 인하여 충북대학교스마트안심산모24 홈페이지 서비스 이용에 불이익을 받지 않으나 이 경우 개인정보 이용목적에 있는 서비스제공이 불가 또는 지연될 수 있습니다. (단, 상기 내용의 서비스 제공을 받지 못하여 발생한 불이익은 정보주체인 본인에게 책임이 있습니다.)
				</span>
			</div>
			<div id="loginCenterRight">
				<div class="login-form">
					<span class="login-name bold">회원가입</span>
					<div class="login-mode">
						<button type="button" :class="isMode == 2 ? 'mode' : ''" @click="selectMode(2)">모니터링 담당자</button>
						<button type="button" :class="isMode == 3 ? 'mode' : ''" @click="selectMode(3)">코디네이터</button>
					</div>
					<!-- <div>
						<p class="account-title">Find ID</p>
						<input
							type="text"
							class="input-login-style sha-focus-666 bmargin-15"
							placeholder="Please enter yout email."
							v-model="item.findIdEmail"
							style="width:calc(70% - 20px); margin: 0 20px 0 0;"
							@keyup="idValidating()"
						/>
						<button type="button" class="button-blue" style="width: 25%;" @click="findId()">Find ID</button>
						<p class="txt-validation" v-if="!idValidate">
							* Email is required
						</p>
					</div> -->
					<input
						type="text"
						maxlength="15"
						name="userId"
						class="input-login-style sha-focus-666 bmargin-15"
						placeholder="아이디"
						style="margin-top: 2.2vh"
						v-model="item.userId"
						v-validate="'required'"
						data-vv-as="User ID"
						autocomplete="off"
						@keyup="doIdDuplicateCheck()"
					/>
					<p class="txt-validation" v-if="errors.has('userId')">
						* {{ errors.first("userId") }}
					</p>
					<p class="txt-validation" v-if="isIdDuplicate">
						* ID is duplicated.
					</p>
					<input
						type="password"
						maxlength="30"
						name="password"
						class="input-login-style sha-focus-666 bmargin-15"
						placeholder="비밀번호"
						style="margin-top: 1vh;"
						v-model="item.password"
						v-validate="'required'"
						data-vv-as="Password"
						ref="password"
					/>
					<p class="txt-validation" v-if="errors.has('password')">
						* {{ errors.first("password") }}
					</p>
					<input
						type="password"
						maxlength="30"
						name="confirmPassword"
						class="input-login-style sha-focus-666 bmargin-15"
						placeholder="비밀번호 확인"
						style="margin-top: 1vh;"
						v-model="item.confirmPassword"
						v-validate="'required|confirmed:password'"
						data-vv-as="Confirm Password"
					/>
					<p class="txt-validation" v-if="errors.has('confirmPassword')">
						* {{ errors.first("confirmPassword") }}
					</p>
					<input
						type="text"
						maxlength="50"
						name="userName"
						class="input-login-style sha-focus-666 bmargin-15"
						placeholder="이름"
						style="margin-top: 1vh;"
						v-model="item.userName"
						v-validate="'required'"
						data-vv-as="User Name"
					/>
					<p class="txt-validation" v-if="errors.has('userName')">
							* {{ errors.first("userName") }}
					</p>
					<div class="phone-wrap" style="margin-top: 1vh; width: 24vw;"> 
						<input type="text" v-validate="'required'" maxlength="3" placeholder="전화번호" class="input-login-style input-crud input-crud2" v-model="item.phoneFront" ref="phoneFront" @keyup="phoneNext('phoneFront', 'phoneCenter')" />
						<span>-</span>
						<input type="text" maxlength="4" class="input-crud input-crud2" v-model="item.phoneCenter" ref="phoneCenter" @keyup="phoneNext('phoneCenter', 'phoneEnd')" />
						<span>-</span>
						<input type="text" maxlength="4" class="input-crud input-crud2" v-model="item.phoneEnd" ref="phoneEnd" />
					</div>
					<div class="email-wrap" style="margin-top: 1vh; width: 24vw;">
						<input type="text" v-validate="'required'" placeholder="이메일" class="input-login-style input-crud input-crud2" v-model="item.emailFront" />
						<span>@</span>
						<input type="text" class="input-crud input-crud2" v-model="item.emailEnd" />
					</div>
					<button type="submit" class="login-button">
						회원가입 신청
					</button>
					<div class="login-sub">
						<button type="button" @click="doCancel()">로그인</button>
					</div>

				</div>
			</div>
		</div>
	</form>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
export default {
	name: "SignUp",
	created() {
		this.logger.debug(this, "created()");
		EventBus.$emit("project-loading", false);
	},
	data() {
		return {
			item: {},
			isMode: 2,
			isIdDuplicate: false,
		};
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");

			if(this.item.emailFront && this.item.emailEnd)
			{
				var emailAddress = this.item.emailFront + "@" + this.item.emailEnd;
				this.$set(this.item, "emailAddress", emailAddress);
			}
			else if(this.item.emailFront || this.item.emailEnd)
			{
				var emailEmpty = (!this.item.emailFront ? "Email Front" : "Email End");
				this.$alert(emailEmpty + " Field is Empty!","Warning","warning");
				return ;
			}

			if(this.item.phoneFront && this.item.phoneCenter && this.item.phoneEnd)
			{
				var mobileTelno = this.item.phoneFront + "-" + this.item.phoneCenter + "-" + this.item.phoneEnd;
				this.$set(this.item, "mobileTelno", mobileTelno);
			}
			else if(this.item.phoneFront || this.item.phoneCenter || this.item.phoneEnd)
			{
				var phoneEmpty = (!this.item.phoneFront ? "Phone Front" : (!this.item.phoneCenter ? "Phone Center" : "Phone End"));
				this.$alert(phoneEmpty + " Field is Empty!","Warning","warning");
				return ;
			}
			this.$set(this.item, "authNo", this.isMode);

			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result) {
						this.$confirm("회원가입 하시겠습니까?", "Question", "question").then(() => {
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectMode(code){
			if(code == 2){ this.isMode = 2;}
			else{this.isMode = 3;}
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");

			axios
				.post(this.config.contextRoot + "/login/signUp.do", this.item)
				.then((response) => {
					if(response.status == 200) {
						this.$alert("회원가입에 성공하였습니다!","Success","success");
						this.$router.push(this.config.contextRoot + "/login");	
					} else {
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
			
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$router.push(this.config.contextRoot + "/login");
		},
		doIdDuplicateCheck() {
			this.logger.debug(this, "doIdDuplicateCheck()");
			
			axios
				.post(this.config.contextRoot + "/login/confirmId.do", this.item)
				.then((response) => {
					if(response.data.count > 0) {
						this.isIdDuplicate = true;
					} else {
						this.isIdDuplicate = false;
					}
				})
					.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		phoneNext(now, next) {
			if(!this.utils.isNull(this.item.phoneFront))
			{
				if(now == "phoneFront" && this.item.phoneFront.length == 3) {
				this.$refs[next].focus();
				}
			}
						
			if(!this.utils.isNull(this.item.phoneCenter))
			{
				if(now == "phoneCenter" && this.item.phoneCenter.length == 4) {
					this.$refs[next].focus();
				}
			}
		}
	},
};
</script>
<style scoped>
.signUpForm{
	height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.txt-validation{
	margin-right: auto;
}
@media ( max-width: 1200px) {
    .media {
        width: max-content;
    }
}
</style>
